<template>
    <div id="chome">
         <div class="header">
             <div>当前登录账号：{{phone}}</div>
             <div class="logout color-l " @click="logout" v-track="{ name: 'checkScore_loginout' }">退出</div>
         </div>

         <van-list
            :finished="finished"
            :finished-text="finishedText"
            v-model="loading"
            :offset="10"
            :immediate-check="false"
            @load="getExamList"
            v-if="examlist && examlist.length > 0"
          >

            <exam-card v-for="(exam,index) in examlist" :examMsg="exam" :key="index"></exam-card>


        </van-list>

        <div class="c-noexam" v-if="examlist && examlist.length == 0">
            <img class="noexam" :src="require('@/assets/noexam.png')" />
            <p>当前暂无考试成绩~</p>
        </div>

        <van-loading class="loading" type="spinner" v-if="examlist == null" />

    </div>
</template>

<script>

import examCard from  "@/components/examCard.vue"
import List from 'vant/lib/list';
import "vant/lib/list/style";

import Loading from 'vant/lib/loading';
import "vant/lib/loading/style";

import { api_examlist } from "@/api"


export default {
  name: 'Home',
  data(){
      return {
          finishedText: "",
          finished: false,
          loading: false,
          userinfo:null,
          start:0,
          rows:3,
          examlist:null,
          examtotal:null

      }
  },
  components: {
       'van-list': List,
       'exam-card':examCard,
       'van-loading':Loading,
  },
  computed:{
      phone(){
          if(this.userinfo.userCode){
             return this.userinfo.userCode.slice(0,3) + "****" +  this.userinfo.userCode.slice(-4)

          }else{
              return ""
          }
      }
  },
  methods:{

    logout(){
        this.$store.dispatch('act_logout').then(() => {
        })
        this.$router.push({
          path: '/login',
          query: {
            from: encodeURIComponent('/home')
          }
        })
    },
    async getExamList(){


         api_examlist(this.userinfo.studentName,
            this.userinfo.schoolGuid,
            this.start,this.rows,
            this.userinfo.currentGrade,
            this.$store.state.token
            )
        .then(res=>{
            console.log("api_examlist ",res);
            this.examlist = this.examlist.concat(res.data.list);
            this.start = res.data.startIndex;
            if(res.data.list.length < this.rows){
                this.finished = true;
            }else{
                this.loading = false;
            }
        }).catch(ex=>console.log(ex));

        }

},
  mounted(){

  },
  created(){
    this.$track('start_checkScore')
    this.$store.dispatch('share/initShareParams', {
      title: '七天学堂学情查询',
      desc: '快来看看你的学情分析报告'
    })
    this.userinfo = this.$store.state.userInfo
    api_examlist(this.userinfo.studentName,
    this.userinfo.schoolGuid,
    this.start,this.rows,
    this.userinfo.currentGrade,
    this.$store.state.token
    )
    .then(res=>{
        console.log("api_examlist ",res);
        this.examlist = res.data.list;
        // this.examtotal = res.data.total;
        this.start = res.data.startIndex;
        if(res.data.list.length < this.rows){
            this.finished = true;
        }
    }).catch(ex=>console.log(ex));
  }
}
</script>

<style  lang="scss" >


    #chome{
        padding: 16px;
        background: #fff;

        .header{
            display: flex;
            align-items: center;
            justify-content:space-between;

            .logout{
                border: 1px solid #ed5b68;
                padding: 3px 18px;
                height: 20px;
                border-radius: 13px;
                font-size: 14px;

            }
        }

        .loading{
            position: absolute;
            left: 50%;
            top:50%;
            transform: translate(-50%,-50%);
        }

        .c-noexam{
            position: absolute;
            left: 50%;
            top:50%;
            transform: translate(-50%,-60%);
            width: 280px;
            // height: 200px;
            overflow: hidden;
            text-align: center;
            .noexam{
                width: 100%;
            }
        }

    }


</style>
